export default __webpack_public_path__ + "static/media/fire-bucket-icon.f2b7033f.svg";